import { render, staticRenderFns } from "./address-info-dialog.vue?vue&type=template&id=3ef85f46&scoped=true"
import script from "./address-info-dialog.vue?vue&type=script&lang=js"
export * from "./address-info-dialog.vue?vue&type=script&lang=js"
import style0 from "./address-info-dialog.vue?vue&type=style&index=0&id=3ef85f46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef85f46",
  null
  
)

export default component.exports